<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M6.750 9.750 A5.250 5.250 0 1 0 17.250 9.750 A5.250 5.250 0 1 0 6.750 9.750 Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M18.913,20.876a9.746,9.746,0,0,0-13.826,0"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
    <path
      d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    ></path>
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconBurgerMenu",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {}
};
</script>